import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { TranslocoPipe } from '@jsverse/transloco';
import { SeeMoreTextComponent } from '@rma/public/generic/ui/see-more-text';
import { ProfileAvatarComponent } from '@rma/public/profiles/public/ui-profile-avatar';
import { StarRatingSummaryComponent } from '@rma/public/reviews/public/ui-rating';
import { MarketReport } from '../domain';
import { MarketReportTopAwardComponent } from '../ui-market-report-top-award/market-report-top-award.component';

@Component({
  selector: 'rma-market-report-header',
  templateUrl: './market-report-header.component.html',
  styleUrls: ['./market-report-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCardModule,
    ProfileAvatarComponent,
    StarRatingSummaryComponent,
    MarketReportTopAwardComponent,
    MatButtonModule,
    NgTemplateOutlet,
    SeeMoreTextComponent,
    TranslocoPipe,
  ],
})
export class MarketReportHeaderComponent {
  @Input() public report!: MarketReport;
}
